var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageStatus === 'rightDetail')?_c('RightDetail',{on:{"changeToLeader":function($event){return _vm.changeToLeader()}}}):_vm._e(),(_vm.pageStatus === 'leader')?_c('RightLeader',{on:{"changeToDetail":_vm.changeToDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }